import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import T, { Translate } from '../../i18n/i18n';
import { SceneryItem, Error, SceneryFullButtonForm, SceneryList, SceneryLabel, SceneryInput, ScenerySelect, SceneryField, SceneryForm, SceneryProps, SceneryActionConfirm, SceneryAction, SceneryActionConfirmButtons, SceneryActive } from './SceneryList.styles';
import { gridtoolsActions } from '../../../redux/actions';
import { listGrids, createGrid, updateGrid, deleteGrid, getGrid, setGridActive } from '../../../services/grids';

export default ({tableId}) => {

    const dispatch = useDispatch();
    const [isAddingScenery, setIsAddingScenery] = useState(false);
    const [isConfirmingActionScenery, setIsConfirmingActionScenery] = useState(false);
    const [sceneryNameValue, setSceneryNameValue] = useState('');
    const [sceneryGridType, setSceneryGridType] = useState('');
    const [sceneryGridScale, setSceneryGridScale] = useState(1.5);
    const [sceneryGridUnit, setSceneryGridUnit] = useState('m');
    const [sceneryGridMeasureType, setSceneryGridMeasureType] = useState('');
    const [sceneryList, setSceneryList] = useState([]);
    const [scenerySelectedId, setScenerySelectedId] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');

    const updateGridList = useCallback((grids) => {
        if (grids && grids.payload && grids.status === 'ok') {
            setSceneryList(grids.payload || []);
            
            let gridsData = grids.payload || [];
            for(let grid of gridsData) {
                if (grid.active) {
                    dispatch(gridtoolsActions.setActiveGridId(grid.id));
                }
            }

            return true;
        }
        return false;
    }, [dispatch]);

    useEffect(() => {
        (async () => {
            let grids = await listGrids(tableId);

            updateGridList(grids);

            let gridsData = grids.payload || [];
            for(let grid of gridsData) {
                if (grid.active) {
                    setScenerySelectedId(grid.id);
                    dispatch(gridtoolsActions.setPropsGrid(grid));
                    break;
                }
            }
        })();
    }, [dispatch, updateGridList, tableId]);

    useEffect(() => {
        (async () => {
            if (scenerySelectedId !== null) {
                let grid = await getGrid(tableId, scenerySelectedId);
                dispatch(gridtoolsActions.setSelectedGrid(scenerySelectedId));
                dispatch(gridtoolsActions.setLoadedGrid(grid.payload.grid));
                dispatch(gridtoolsActions.setPropsGrid(grid.payload.grid));
            }
        })();
    }, [dispatch, tableId, scenerySelectedId])

    const handleAddScenery = async () => {
        setErrorMessage('');
        let grids = await createGrid(tableId, {
            name: sceneryNameValue,
            gridType: sceneryGridType,
            gridScale: sceneryGridScale,
            gridUnit: sceneryGridUnit,
            gridMeasureType: sceneryGridMeasureType,
        });
        if (updateGridList(grids)) {
            let gridId = grids.payload[grids.payload.length-1].id;
            setScenerySelectedId(gridId);
        }

        setSceneryNameValue('');
        setIsAddingScenery(false);
    }

    const handleEditScenery = async () => {
        setErrorMessage('');
        let grids = await updateGrid(tableId, {
            id: scenerySelectedId,
            name: sceneryNameValue,
            gridType: sceneryGridType,
            gridScale: sceneryGridScale,
            gridUnit: sceneryGridUnit,
            gridMeasureType: sceneryGridMeasureType,
        });
        updateGridList(grids);

        let gridList = grids ? (grids.payload || []) : [];
        for(let grid of gridList) {
            if (grid.id === scenerySelectedId) {
                dispatch(gridtoolsActions.setPropsGrid(grid));
            }
        }

        setSceneryNameValue('');
        setIsAddingScenery(false);
        setSceneryGridType('');
        setSceneryGridScale(1.5);
        setSceneryGridUnit('m');
        setSceneryGridMeasureType('');
    }

    const handleRemoveScenery = () => {
        setIsConfirmingActionScenery(true);
    }

    const handleCancelRemoveScenery = () => {
        setIsConfirmingActionScenery(false);
    }

    const handleConfirmRemoveScenery = async () => {
        let grids = await deleteGrid(tableId, {id: scenerySelectedId});

        if (grids.status === 'ok') {
            updateGridList(grids);
            setScenerySelectedId(grids.payload[0].id);
        } else {
            setErrorMessage(grids.payload);
        }

        setSceneryNameValue('');
        setIsAddingScenery(false);
        setIsConfirmingActionScenery(false);
    }

    const handleSelectScenery = async (item) => {
        setErrorMessage('');
        setIsAddingScenery(true);
        setScenerySelectedId(item.id);
        setSceneryNameValue(item.name);
        setSceneryGridType(item.gridType ?? '');
        setSceneryGridScale(item.gridScale ?? 1.5);
        setSceneryGridUnit(item.gridUnit ?? 'm');
        setSceneryGridMeasureType(item.gridMeasureType ?? '');

        dispatch(gridtoolsActions.setPropsGrid(item));
    }

    const handleSceneryInputKeypress = (e)=> {
        if (e.which === 13) {
            if (sceneryNameValue.length > 0) {
                if (scenerySelectedId === null) {
                    handleAddScenery();
                } else {
                    handleEditScenery();
                }
            } else {
                setIsAddingScenery(false);
            }
        }
    }

    const handleCancelSelect = () => {
        setSceneryNameValue('');
        setIsAddingScenery(false);
        setSceneryGridType('');
        setSceneryGridScale(1.5);
        setSceneryGridUnit('m');
        setSceneryGridMeasureType('');
    }

    const handleSetActiveScenery = async () => {
        let grids = await setGridActive(tableId, scenerySelectedId);
        updateGridList(grids);
        
        let gridList = grids ? (grids.payload || []) : [];
        for(let grid of gridList) {
            if (grid.id === scenerySelectedId) {
                dispatch(gridtoolsActions.setPropsGrid(grid));
            }
        }
    }

    const handleSceneryGridScale = (v) => {
        const str = v.replace(/[^\d,.]/gi,'').replace(/,/gi,'.');
        const value = str.split('.');
        const decimal = value.length > 1 ? (value[value.length-1] ?? 0) : 0;
        const integer = value.length > 1 ? value.splice(0,value.length-1).join() : value[0];
        const final = parseFloat(integer+'.'+decimal);
        setSceneryGridScale(String(final + (str.charAt(str.length-1) === '.' ? '.' : '')));
    }


    return <>
        <SceneryList className="scrollbar">
            {sceneryList.map((i, k) => {return <SceneryItem 
                key={k} 
                className={scenerySelectedId === i.id ? 'selected' : ''}
                onClick={() => {handleSelectScenery(i)}}
            >{i.name}{i.active && <SceneryActive><T value="gridtools.sceneryactive" /></SceneryActive>}</SceneryItem>})}
        </SceneryList>
        { !isAddingScenery && !isConfirmingActionScenery && errorMessage &&
            <Error>{errorMessage}</Error>
        }
        { !isAddingScenery && !isConfirmingActionScenery && !errorMessage &&
            <SceneryFullButtonForm onClick={() => {setScenerySelectedId(null); setSceneryNameValue(''); setIsAddingScenery(true)}}>
                <T value="gridtools.addScenery"/>
            </SceneryFullButtonForm>}
        { isAddingScenery && !isConfirmingActionScenery && <SceneryForm>
            <SceneryField>
                <SceneryLabel><T value="gridtools.sceneryname"/></SceneryLabel>
                <SceneryLabel><T value="gridtools.scenerygridtype"/></SceneryLabel>
            </SceneryField>
        </SceneryForm> }
        {isConfirmingActionScenery && <>
            <SceneryActionConfirm>
                <SceneryLabel><T value="gridtools.confirmdelete"/></SceneryLabel>
                <SceneryActionConfirmButtons>
                    <SceneryAction onClick={handleConfirmRemoveScenery} color={'#f33'}><T value="yes"/></SceneryAction>
                    <SceneryAction onClick={handleCancelRemoveScenery} color={'#33f'}><T value="no"/></SceneryAction>
                </SceneryActionConfirmButtons>
            </SceneryActionConfirm>
        </>}
        {isAddingScenery && !isConfirmingActionScenery && <SceneryProps>
            <SceneryField>
                <SceneryInput type="text" value={sceneryNameValue} onChange={(e)=>{setSceneryNameValue(e.target.value);}} onKeyPress={handleSceneryInputKeypress}/>
                <ScenerySelect value={sceneryGridType} onChange={(e)=>{setSceneryGridType(e.target.value);}}>
                    <option value={'square'}>{ Translate("gridtools.scenerygridsquare") }</option>
                    <option value={'hexagon'}>{ Translate("gridtools.scenerygridhex") }</option>
                </ScenerySelect>
            </SceneryField>
            <SceneryField>
                <SceneryField internal first>
                    <SceneryLabel><T value="gridtools.scenerygridscale"/></SceneryLabel>
                    <SceneryLabel><T value="gridtools.scenerygridunit"/></SceneryLabel>
                </SceneryField>
                <SceneryLabel><T value="gridtools.scenerygridmeasuretype"/></SceneryLabel>
            </SceneryField>
            <SceneryField>
                <SceneryField internal first>
                    <SceneryInput value={sceneryGridScale} onChange={(e)=>{handleSceneryGridScale(e.target.value);}}/>
                    <SceneryInput value={sceneryGridUnit} onChange={(e)=>{setSceneryGridUnit(e.target.value);}}/>
                </SceneryField>
                <ScenerySelect value={sceneryGridMeasureType} onChange={(e)=>{setSceneryGridMeasureType(e.target.value);}}>
                    <option value={'precise'}>{ Translate("gridtools.scenerygridmeasureprecise") }</option>
                    <option value={'diamond'}>{ Translate("gridtools.scenerygridmeasurediamond") }</option>
                    <option value={'square'}>{ Translate("gridtools.scenerygridmeasuresquare") }</option>
                </ScenerySelect>
            </SceneryField>
            <SceneryForm>
                {scenerySelectedId === null && <SceneryFullButtonForm color={'#0C0'} onClick={() => {handleAddScenery();}}><T value="gridtools.sceneryedit"/></SceneryFullButtonForm>}
                {scenerySelectedId !== null && <>
                    <SceneryFullButtonForm color={'#0c0'} onClick={() => {handleSetActiveScenery();}}><T value="gridtools.sceneryactivate" /></SceneryFullButtonForm>
                    <SceneryFullButtonForm color="#36f" onClick={() => {handleEditScenery();}}><T value="gridtools.sceneryedit"/></SceneryFullButtonForm>
                    <SceneryFullButtonForm color={'#fa3'} onClick={() => {handleRemoveScenery();}}><T value="delete" /></SceneryFullButtonForm>
                </>}
                <SceneryFullButtonForm color="#F44" onClick={() => {handleCancelSelect();}}>
                    <T value="cancel"/>
                </SceneryFullButtonForm>
            </SceneryForm>
        </SceneryProps>}
    </>
}